/**
 * The suite chevron on olive (design 10.1): three white chevrons rising in opacity, the geometry of the suite's
 * mark, on Olivia's olive #5E6B25, distinct from Gap Assessor's blue and ALEXANDER's teal.
 */

export function Mark({ size = 28, label }: { size?: number; label: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={label}>
      <rect width="64" height="64" rx="14" fill="#5E6B25" />
      <g fill="none" stroke="#FFFFFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="18,44 32,32 46,44" opacity="0.45" />
        <polyline points="18,34 32,22 46,34" opacity="0.7" />
        <polyline points="18,24 32,12 46,24" />
      </g>
    </svg>
  )
}
